import { render, staticRenderFns } from "./ReceiveInfo.vue?vue&type=template&id=60eda9d8&scoped=true&"
import script from "./ReceiveInfo.vue?vue&type=script&lang=js&"
export * from "./ReceiveInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eda9d8",
  null
  
)

export default component.exports